import React, { FC } from 'react';

import { Popup } from 'antd-mobile';

import './index.scss';

import PlainModal from '../Base/PlainModal';

interface ModelProps {
  open: boolean;
  children: React.ReactNode;
  onCancel: () => void;
  className?: string;
}

const ResponsiveModal: FC<ModelProps> = ({ open, children, onCancel, className }) => {
  return (
    <>
      <div className='hidden md:block'>
        <PlainModal open={open} onClickMask={onCancel} className={`${className} hidden md:block`}>
          <section className={`responsive-modal w-[674px] ${className}`}>{children}</section>
        </PlainModal>
        ·
      </div>
      {/* 移动端模态框 */}
      <Popup
        visible={open}
        onClose={onCancel}
        onMaskClick={onCancel}
        className='z-[1001] block md:hidden'
        bodyClassName='bg-col_text05 p-4 pb-3'
        position='bottom'
        bodyStyle={{
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          padding: 0,
          maxHeight: '90vh',
        }}
      >
        {children}
      </Popup>
    </>
  );
};

export default ResponsiveModal;
